<template>
  <div>
    <v-layout row justify-center>
      <v-dialog v-model="dialog" persistent max-width="400px">
        <v-card color="grey lighten-2">
          <v-flex xs12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title>{{dialog_baslik}}</v-toolbar-title>

            </v-toolbar>
          </v-flex>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout row="" wrap>

                <!-- FaturaId: 0,
          int: 0,
          XsltAciklama: 0,
          XsltAd: 0,
          XsltId: 0,
          string XsltAd1: 0,
          string XsltId1: 0
 -->


                <div class="flex md12">


                  <v-text-field label="Açıklama" :color="color" v-model="ListInput.XsltAciklama">
                  </v-text-field>
                  <v-form ref="formaktarim" id="formaktarim" method="post" enctype="multipart/form-data" v-model="valid"
                    lazy-validation>
                    <input hidden type="file" id="file" ref="file" multiple v-on:change="handleFileUpload()" />
                  </v-form>
                  <v-form ref="formaktarim2" id="formaktarim2" method="post" enctype="multipart/form-data" v-model="valid2"
                    lazy-validation>
                    <input hidden type="file" id="file2" ref="file2" multiple v-on:change="handleFileUpload2()" />
                  </v-form>
                  <v-layout>
                    <v-text-field label="XSLT Dosya Adı E-Fatura" :placeholder="dosya1mesaj" append-icon="attach_file"
                      :append-icon-cb="addFiles" :color="color" v-model="dosyayolu1">
                    </v-text-field>
                    <v-tooltip bottom="" :activator="el" v-model="tooltip">
                      <span>Yükle</span>
                    </v-tooltip>
                  </v-layout>
                  <v-text-field label="E-Fatura Dış Id" :color="color" v-model="ListInput.XsltId">
                  </v-text-field>
                  <v-layout>

                    <v-text-field label="XSLT Dosya Adı E-Fatura" :placeholder="dosya2mesaj" append-icon="attach_file"
                      :append-icon-cb="addFiles2" :color="color" v-model="dosyayolu2">
                    </v-text-field>

                    <!-- <v-btn small="" fab  @mouseenter="tooltip = true" @mouseleave="tooltip = false" ref="fab" @click="SubmitFile()"
                        color="info" dark>
                        <v-icon>restore_page</v-icon>
                      </v-btn> -->
                    <!-- <v-tooltip bottom="" :activator="el" v-model="tooltip">
                        <span>Yükle</span>
                      </v-tooltip> -->
                  </v-layout>
                  <v-text-field label="E-Arşiv Dış Id" :color="color" v-model="ListInput.XsltId1">
                  </v-text-field>
                </div>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <div v-show="m === true">
              <v-btn id="bguncelle" color="blue darken-1" flat @click="guncelle()">Güncelle</v-btn>
              <v-btn id="bsil" color="blue darken-1" flat @click="silsor()">Sİl</v-btn>
            </div>

            <v-btn color="blue darken-1" flat @click="vazgec()">VazgeÇ</v-btn>
            <div v-show="k === true">
              <v-btn v-if="k==true" id="bkaydet" color="blue darken-1" flat @click="Kaydet()">Kaydet</v-btn>
            </div>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <v-layout row wrap>
      <v-toolbar dark color="info">
        <v-toolbar-title class="baslikfont">Fatura XSLT</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <v-text-field flat="" solo-inverted="" hide-details v-model="search3" label=" Ara" append-icon="search"></v-text-field>
        <v-btn hidden="xs" flat @click="dosyaekle()"> XSLT Ekle
          <v-icon right dark>add_box</v-icon>
        </v-btn>
      </v-toolbar>
    </v-layout>

    <v-card>
      <v-card-title>
        <v-spacer></v-spacer>

      </v-card-title>
      <v-data-table :headers="headers" :rows-per-page-items=[50,100] :loading="progress" :items="xsltitems" :search="search3">
        <v-progress-linear slot="progress" indeterminate></v-progress-linear>

        <template slot="items" slot-scope="props">
          <tr @click="Getir(props.item)" item>
            <td class="text-xs-left">{{ props.item.FaturaId }}</td>
            <td class="text-xs-left">{{ props.item.XsltAciklama }}</td>
            <td class="text-xs-left">{{ props.item.XsltAd }}</td>
            <td class="text-xs-left">{{ props.item.XsltAd1 }}</td>
          </tr>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">
          Aradığınız "{{ search3 }}" kelimesi ile ilgili herhangi bir kayıt bulunamadı..
        </v-alert>
      </v-data-table>
    </v-card>

    <template>
      <v-card>
        <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'" :left="x === 'left'"
          :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
          {{ text1 }}
          <v-btn flat color="pink" @click.native="snackbar = false">Kapat</v-btn>
        </v-snackbar>
      </v-card>
      <v-dialog v-model="dialog1" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">Uyarı !</v-card-title>
          <v-card-text>{{dialogmessage1}}</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="info" flat @click.native="dialog1=false">İptal</v-btn>

            <v-btn color="info" flat @click="xsltsil()">Tamam</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

    </template>
  </div>
</template>


<script>
  import auth from '../../../api/auth'
  import axios from 'axios'


  export default {
    data() {
      return {

        xsltitems: [],
        ListInput: {
          FaturaId: null,
          SirketKodu: null,
          XsltAciklama: null,
          XsltAd: null,
          XsltId: null,
          XsltAd1: null,
          XsltId1: null
        },
        valid: true,
        valid2: true,
        file: [],
        file2: [],
        tooltip: false,
        el: null,
        text1: null,
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
        dosya1mesaj: null,
        dosya2mesaj: null,
        yenikayit: false,
        dosyayolu1: null,
        dosyayolu2: null,
        dosyaokearsiv: false,
        dosyaokefatura: false,


        headers: [{
            text: 'Fatura Id',
            value: 'FaturaId+'
          },
          {
            text: 'Açıklama',
            value: 'XsltAciklama'
          },
          {
            text: 'E-Fatura Dosya',
            value: 'XsltAd'
          },
          {
            text: 'E-Arşiv Dosya',
            value: 'XsltAd1'
          }
        ],
        loading: false,
        color: 'orange darken-4',
        yedeksirket: [],
        items: [],
        search3: '',
        search: null,
        select: [],
        selected: '',
        m: false,
        k: false,
        dialog: false,
        dialog1: false,
        dialogmessage1: '',
        Sirket: {
          CompanyCode: '',
          CompanyName: '',
          CompanyTitle: ''
        },
        state: [],
        yenisirket: {
          id: '',
          text: '',
          unvan: ''
        },
        dialog_baslik: '',
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
        text: '',
        text1: '',
        bankakod: '',
        bankaadi: '',
        progress: false,
        dictionary: {
          custom: {
            sirketkod: {
              required: () => 'Bu alan boş bırakılamaz',
            },
            sirketadi: {
              required: () => 'Bu alan boş bırakılamaz',
            }
          }
        }
      }
    },
    watch: {
      search(val) {
        val && this.carigetir(val)
      }
    },
    mounted() {
      this.$validator.localize('en', this.dictionary)
    },
    methods: {

      silsor() {
        this.dialogmessage1 = "XSLT kaydını silmek istediğinize emin misiniz?";
        this.dialog1 = true;
      },
      addFiles() {
        this.$refs.file.click();
      },
      addFiles2() {
        this.$refs.file2.click();
      },

      handleFileUpload() {
        this.file = []
        var cred = JSON.parse(window.localStorage.getItem('credentials'));
        if (this.$refs.file.files.length > 0) {
          var uploadedFiles = this.$refs.file.files;
          if (uploadedFiles[0].type == 'application/xml') {
            this.dosyayolu1 = 'C:\\Arkman\\Musteriler\\' + cred.AnaSirketKodu + '\\EArsiv\\' + uploadedFiles[0].name;

            for (var i = 0; i < uploadedFiles.length; i++) {
              this.dosyaokearsiv = true;
              this.file.push(uploadedFiles[i]);
            }
          } else {
            this.dosya1mesaj = 'Lütfen xslt uzantılı bir dosya seçiniz.'
            this.snacakbar = true
          this.dosyaokearsiv = false;
            this.uploadedFiles = [];
            this.file = [];
            this.dosyayolu1 = '';
          }
        } else {
          this.dosyaokearsiv = false;
        }
         const input = this.$refs.file;
            input.type = 'text';
            input.type = 'file';

      },
      handleFileUpload2() {

        var cred = JSON.parse(window.localStorage.getItem('credentials'));
        this.file2 = []
        if (this.$refs.file2.files.length > 0) {
          var uploadedFiles2 = this.$refs.file2.files;
          if (uploadedFiles2[0].type == 'application/xml') {
            this.dosyaokefatura = true;
            this.dosyayolu2 = 'C:\\Arkman\\Musteriler\\' + cred.AnaSirketKodu + '\\EFatura\\' + uploadedFiles2[0]
              .name;
            for (var i = 0; i < uploadedFiles2.length; i++) {
              this.file2.push(uploadedFiles2[i]);
            }
          } else {
            this.dosya2mesaj = 'Lütfen xslt uzantılı bir dosya seçiniz.'
            this.snacakbar = true
            const input = this.$refs.file2;
            input.type = 'text';
            input.type = 'file';
            this.file2 = [];
            this.uploadedFiles2 = [];
            this.dosyayolu2 = '';
          }
        } else {
          this.dosyaokefatura = false;
        }
         const input = this.$refs.file2;
            input.type = 'text';
            input.type = 'file';
      },

      Getir(v) {
        this.yenikayit = false,
          this.k = false
        this.m = true
        this.codegorunum = false
        this.dialog = true
        this.dialog_baslik = 'XSLT Güncelle'
        this.ListInput.FaturaId = v.FaturaId
        this.ListInput.XsltAciklama = v.XsltAciklama
        this.dosyayolu1 = v.XsltAd
        this.ListInput.XsltId = v.XsltId
        this.dosyayolu2 = v.XsltAd1
        this.ListInput.XsltId1 = v.XsltId1
      },
      xsltsil: xsltsil,
      dosyaekle: dosyaekle,
      Kaydet: Kaydet,
      guncelle: guncelle,
      vazgec: vazgec
    },
    beforeMount: beforeMount,
    vazgec: vazgec
  }

  function vazgec() {
    this.dialog = false
  }


  function Kaydet() {
    if (this.file.length > 0) {
      var cred = JSON.parse(window.localStorage.getItem('credentials'));
      let formData = new FormData();
      for (var i = 0; i < this.file.length; i++) {
        let file = this.file[i];
        formData.append('file[' + i + ']', file);
      }
      formData.append('CustomerCode', cred.AnaSirketKodu)
      formData.append('TransferType', '0')
      axios.defaults.baseURL = auth.API_URL;
      axios.defaults.headers.post['Content-Type'] = 'multipart/form-data';
      axios.post(auth.API_URL + 'api/TicketDefinitons/FileUploadxslt',
          formData, {
            headers: {
              Authorization: `Bearer ${auth.getAuthHeader()}`
            }
          }
        ).then((response) => {

          if (response.data == true) {

            this.load2 = true
            this.load = false
            this.text1 = "Xslt Aktarımları Tamamlandı"
            this.snackbar = true
          } else {
            this.text1 = "Xslt dosyalarınız aktarılamadı. Tekrar deneyiniz."
            this.snackbar = true
          }
        })
        .catch(function () {});
    }

    if (this.file2.length > 0) {
      var cred = JSON.parse(window.localStorage.getItem('credentials'));
      let formData = new FormData();
      for (var i = 0; i < this.file2.length; i++) {
        let file = this.file2[i];
        formData.append('file[' + i + ']', file);
      }
      formData.append('CustomerCode', cred.AnaSirketKodu)
      formData.append('TransferType', '1')
      axios.defaults.baseURL = auth.API_URL;
      axios.defaults.headers.post['Content-Type'] = 'multipart/form-data';
      axios.post(auth.API_URL + 'api/TicketDefinitons/FileUploadxslt',
          formData, {
            headers: {
              Authorization: `Bearer ${auth.getAuthHeader()}`
            }
          }
        ).then((response) => {
          if (response.data == true) {
            this.load2 = true
            this.load = false
            this.text1 = "Xslt Aktarımları Tamamlandı"
            this.snackbar = true
          } else {
            this.text1 = "Xslt dosyalarınız aktarılamadı. Tekrar deneyiniz."
            this.snackbar = true
          }
        })
        .catch(function () {
          console.log('hata!!');
        });
    }

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    if (this.dosyaokearsiv = true) {
      this.ListInput.XsltAd = this.dosyayolu1;
    }

    if (this.dosyaokefatura = true) {
      this.ListInput.XsltAd1 = this.dosyayolu2;
    }

    this.ListInput.SirketKodu = credentials.SirketKodu

    var params = this.ListInput

    this.$http.post(auth.API_URL + 'api/TicketInvoice/InvoiceXsltTableSave', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      if (response.body.Status) {
        this.text1 = response.body.ResponseMessage
        this.snackbar = true
        this.dialog = false;
        this.dosyaokefatura = false
        this.dosyaokearsiv = false
        var params3 = {
          CompanyCode: credentials.SirketKodu
        }


        this.$http.post(auth.API_URL + 'api/TicketInvoice/InvoiceXsltTableList', params3, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.xsltitems = response.body
        }, (response) => {
          if (response.status === 0) {
            this.progress = false
            this.text1 = 'Service Unavailable-InvoiceXsltTableList'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable-InvoiceXsltTableList'
            this.snackbar = true
          }
        })










      } else {
        this.text1 = response.body.ResponseMessage
        this.snackbar = true
      }
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      } else {
        this.text1 = response.statusText
        this.snackbar = true
      }
    })
  }

  function dosyaekle() {
    this.file = [];
    this.file2 = [];
    this.ListInput.FaturaId = null;
    this.ListInput.XsltAciklama = null;
    this.dosyayolu1 = null;
    this.dosyayolu2 = null;
    this.ListInput.XsltAd = null;
    this.ListInput.XsltId = null;
    this.ListInput.XsltAd1 = null;
    this.ListInput.XsltId1 = null;
    this.dialog = true
    this.dialog_baslik = 'XSLT Ekle';
    this.k = true;
    this.m = false;
  }

  function beforeMount() {
    var credentials = JSON.parse(window.localStorage.getItem('credentials'));
    var params3 = {
      CompanyCode: credentials.SirketKodu
    }
    this.$http.post(auth.API_URL + 'api/TicketInvoice/InvoiceXsltTableList', params3, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.xsltitems = response.body
    }, (response) => {
      if (response.status === 0) {
        this.progress = false
        this.text1 = 'Service Unavailable-InvoiceXsltTableList'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable-InvoiceXsltTableList'
        this.snackbar = true
      }
    })
  }

  function xsltsil() {
    var credentials = JSON.parse(window.localStorage.getItem('credentials'));
    var params3 = {
      CompanyCode: credentials.SirketKodu,
      InvoiceID: this.ListInput.FaturaId
    }

    this.$http.post(auth.API_URL + 'api/TicketInvoice/InvoiceXsltTableDelete', params3, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {

      if (response.body.Status) {
        this.text1 = response.body.ResponseMessage
        this.snackbar = true
        this.dialog1 = false;
        this.dialog = false;


        var params4 = {
          CompanyCode: credentials.SirketKodu
        }

        this.$http.post(auth.API_URL + 'api/TicketInvoice/InvoiceXsltTableList', params4, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.xsltitems = response.body
        }, (response) => {
          if (response.status === 0) {
            this.progress = false
            this.text1 = 'Service Unavailable-InvoiceXsltTableList'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable-InvoiceXsltTableList'
            this.snackbar = true
          }
        })
      }

    }, (response) => {
      if (response.status === 0) {
        this.progress = false
        this.text1 = 'Service Unavailable-InvoiceXsltTableList'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable-InvoiceXsltTableList'
        this.snackbar = true
      }
    })
  }

  function guncelle() {

    if (this.file.length > 0) {
      var cred = JSON.parse(window.localStorage.getItem('credentials'));
      let formData = new FormData();
      for (var i = 0; i < this.file.length; i++) {
        let file = this.file[i];
        formData.append('file[' + i + ']', file);
      }
      formData.append('CustomerCode', cred.AnaSirketKodu)
      formData.append('TransferType', '0')
      axios.defaults.baseURL = auth.API_URL;
      axios.defaults.headers.post['Content-Type'] = 'multipart/form-data';
      axios.post(auth.API_URL + 'api/TicketDefinitons/FileUploadxslt',
          formData, {
            headers: {
              Authorization: `Bearer ${auth.getAuthHeader()}`
            }
          }
        ).then((response) => {

          if (response.data == true) {

            this.load2 = true
            this.load = false
            this.text1 = "Xslt Aktarımları Tamamlandı"
            this.snackbar = true
          } else {
            this.text1 = "Xslt dosyalarınız aktarılamadı. Tekrar deneniyiniz."
            this.snackbar = true
          }
        })
        .catch(function () {});
    }

    if (this.file2.length > 0) {

      var cred = JSON.parse(window.localStorage.getItem('credentials'));
      let formData = new FormData();
      for (var i = 0; i < this.file2.length; i++) {
        let file = this.file2[i];
        formData.append('file[' + i + ']', file);
      }
      formData.append('CustomerCode', cred.AnaSirketKodu)
      formData.append('TransferType', '1')
      axios.defaults.baseURL = auth.API_URL;
      axios.defaults.headers.post['Content-Type'] = 'multipart/form-data';
      axios.post(auth.API_URL + 'api/TicketDefinitons/FileUploadxslt',
          formData, {
            headers: {
              Authorization: `Bearer ${auth.getAuthHeader()}`
            }
          }
        ).then((response) => {
          if (response.data == true) {
            this.load2 = true
            this.load = false
            this.text1 = "Xslt Aktarımları Tamamlandı"
            this.snackbar = true
          } else {
            this.text1 = "Xslt dosyalarınız aktarılamadı. Tekrar deneniyiniz."
            this.snackbar = true
          }
        })
        .catch(function () {
          console.log('hata!!');
        });
    }

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));
    this.ListInput.SirketKodu = credentials.SirketKodu


    if (this.dosyaokearsiv == true) {
      this.ListInput.XsltAd = this.dosyayolu1;
    }

    if (this.dosyaokefatura == true) {
      this.ListInput.XsltAd1 = this.dosyayolu2;
    }

    var params = this.ListInput

    this.$http.post(auth.API_URL + 'api/TicketInvoice/InvoiceXsltTableSave', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      if (response.body.Status) {

        this.text1 = response.body.ResponseMessage
        this.snackbar = true;
        this.dialog = false;
        this.dosyaokefatura=false;
        this.dosyaokearsiv=false;

        var params3 = {
          CompanyCode: credentials.SirketKodu
        }

        this.$http.post(auth.API_URL + 'api/TicketInvoice/InvoiceXsltTableList', params3, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.xsltitems = response.body
        }, (response) => {
          if (response.status === 0) {
            this.progress = false
            this.text1 = 'Service Unavailable-InvoiceXsltTableList'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable-InvoiceXsltTableList'
            this.snackbar = true
          }
        })
      } else {
        this.text1 = response.body.ResponseMessage
        this.snackbar = true
      }
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      } else {
        this.text1 = response.statusText
        this.snackbar = true
      }
    })


  }
</script>

<style>
</style>